export default __webpack_public_path__ + "static/media/gold_plan.33148559.svg";